import '../EventWaitingRoom.scss';

import React, { useEffect, useState } from 'react';

import flexStyles from '../../../../style/flex-animation.module.scss';

const WaitingRoomStream = props => {
    const {event, session} = props,
        [visible, setVisible] = useState(false),
        {waiting_room_stream_url, waiting_room_stream_enabled} = session;

    useEffect(() => {
        setVisible(session?.waiting_room_stream_url && session?.waiting_room_stream_enabled);
    }, [session]);

    return (
        <div className={['WaitingRoomStream', flexStyles.col, visible ? flexStyles.visible : flexStyles.hidden].join(' ')}>
            {visible ? <iframe src={waiting_room_stream_url} allow="camera;microphone;autoplay;encrypted-media;gyroscope" /> : null}
        </div>
    );
};

export default WaitingRoomStream;
